export default __webpack_public_path__ + "static/dubizzle-white-47b8c54d31ebbbd66504d8ecd301e2ed.png";